import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SalesOrderLine, UpdateShippedOrder } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class UpdateShippedOrderService extends TmsWebBaseEditService<SalesOrderLine, UpdateShippedOrder> {
  constructor() {
    super('UpdateShippedOrder', $localize`Update Shipped Order`);
  }

  updateShippingDetails(ids: string[], trackingNumbers: string[], shipperIds: string[]): Observable<any> {
    return this.httpService.post<any>(`${this.apiUrl}/UpdateShippingDetails`, { ids, trackingNumbers, shipperIds });
  }
}
